import type { InspectionCategory } from '~/contracts/vdp';

const dataSectionColumns = [
  {
    description: 'FROM THE VIN',
    columnOne: [1, 2],
    columnTwo: [3, 3]
  },
  {
    description: 'UNDER THE HOOD',
    columnOne: [4, 24],
    columnTwo: [25, 45]
  },
  {
    description: 'VEHICLE EXTERIOR',
    columnOne: [46, 50],
    columnTwo: [51, 55]
  },
  {
    description: 'VEHICLE INTERIOR',
    columnOne: [56, 77],
    columnTwo: [78, 96]
  },
  {
    description: 'HOW IT DRIVES',
    columnOne: [97, 106],
    columnTwo: [107, 116]
  },
  {
    description: 'HOW IT LOOKS',
    columnOne: [117, 131],
    columnTwo: [132, 145]
  },
  {
    description: 'DETAILING',
    columnOne: [146, 147],
    columnTwo: [148, 150]
  }
];

export function constructColumnData(category: InspectionCategory) {
  const selectedSection = dataSectionColumns.find(
    section => section.description === category.description
  );

  if (!selectedSection) {
    return {
      columnOneData: [],
      columnTwoData: []
    };
  }

  const { inspectionPoints } = category;
  const columnOneData = inspectionPoints.filter(
    point =>
      point.id >= selectedSection.columnOne[0] &&
      point.id <= selectedSection.columnOne[1]
  );
  const columnTwoData = inspectionPoints.filter(
    point =>
      point.id >= selectedSection.columnTwo[0] &&
      point.id <= selectedSection.columnTwo[1]
  );

  return {
    columnOneData,
    columnTwoData
  };
}

export function formatDate(inspectionDate: string) {
  const date = new Date(inspectionDate);
  const day = date?.getDate() <= 9 ? `0${date?.getDate()}` : date?.getDate();
  const incrementMonth = date?.getMonth() + 1;
  const month = incrementMonth <= 9 ? `0${incrementMonth}` : incrementMonth;
  const year = date?.getFullYear();

  return `${month}/${day}/${year}`;
}
